import script from "./WorkspaceUsersTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceUsersTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceUsersTableLoader.vue?vue&type=style&index=0&id=3189ecb9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3189ecb9"]])

export default __exports__